import { EventsDashboard } from "./EventsDashboard";

export default EventsDashboard;
